import * as React from 'react';
import { Button } from '@sitebase/ui-kit';
import { CLASSNAME_PREFIX as cp } from '../componentConfig';
import { HTTP_STATUS_CODE_TOKEN_EXPIRED } from '../constants';
import './ErrorPage.scss';
export default function ErrorPage(_a) {
    var error = _a.error, translate = _a.t;
    var reloadPage = function () { return location.reload(); };
    return (React.createElement("div", { className: cp + "-error-page" },
        React.createElement("span", { className: cp + "-error-page__icon" }),
        error === HTTP_STATUS_CODE_TOKEN_EXPIRED ? (React.createElement("div", null,
            React.createElement("p", { className: cp + "-error-page__title" }, translate('ERROR_TITLE_TOKEN_EXPIRED')),
            React.createElement("p", { className: cp + "-error-page__message" }, translate('ERROR_MESSAGE_TOKEN_EXPIRED')))) : (React.createElement("div", null,
            React.createElement("p", { className: cp + "-error-page__title" }, translate('ERROR_TITLE')),
            React.createElement("p", { className: cp + "-error-page__message" }, translate('ERROR_MESSAGE')),
            React.createElement(Button, { className: cp + "-error-page__button", outfit: "quaternary large expanded", onClick: reloadPage }, translate('ERROR_BUTTON_VALUE'))))));
}
//# sourceMappingURL=ErrorPage.js.map